import 'core-js/features/array/find';
import 'core-js/features/array/find-index';
import 'core-js/features/string/includes';
import 'core-js/features/string/repeat';
import 'core-js/features/string/starts-with';
import 'react-app-polyfill/ie9';

import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider } from '@material-ui/core/styles';
import * as Sentry from '@sentry/browser';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './containers/App';
import theme from './mui-theme';
import * as serviceWorker from './serviceWorker';
import store from './store';
import { getSavedUser, setTitle } from './store/actions';

const { REACT_APP_NAME, REACT_APP_SENTRY_DSN, REACT_APP_VERSION, NODE_ENV } = process.env;

if (NODE_ENV === 'production') {
  Sentry.init({
    dsn: REACT_APP_SENTRY_DSN,
    blacklistUrls: [/https?:\/\/localhost/],
    environment: NODE_ENV,
    release: `${REACT_APP_NAME}@${REACT_APP_VERSION}`
  });

  Sentry.configureScope(scope => {
    scope.setTag('app', REACT_APP_NAME as string);
  });
}

store.dispatch(setTitle('Port of Texas City'));
store.dispatch(getSavedUser() as any);

ReactDOM.render(
  <>
    <CssBaseline />
    <MuiThemeProvider theme={theme}>
      <Provider store={store}>
        <App />
      </Provider>
    </MuiThemeProvider>
  </>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
